/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface SubscriptionBase
 */
export interface SubscriptionBaseOptional {
  /**
   *
   * @type {string}
   * @memberof SubscriptionBase
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof SubscriptionBase
   */
  billingCycle?: string;
}

export interface SubscriptionBase extends SubscriptionBaseOptional {
  /**
   *
   * @type {string}
   * @memberof SubscriptionBase
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SubscriptionBase
   */
  billingCycle: string;
}

export interface SubscriptionBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof SubscriptionBase
   */
  name?: string;
  nameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof SubscriptionBase
   */
  billingCycle?: string;
  billingCycleIsSet: boolean;
}

transformDatesMap.set(
  "SubscriptionBase",
  function (model: SubscriptionBase) {},
);

export type SubscriptionBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  name: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  billingCycle: PropertyMeta<MetaTypeBase<string>>;
}>;

export var SubscriptionBaseMeta: SubscriptionBaseMetaI =
  {} as SubscriptionBaseMetaI;
SubscriptionBaseMeta = typeMeta("SubscriptionBase", {
  name: propertyMeta("name", false, true, false, MetaTypesBase.string),
  billingCycle: propertyMeta(
    "billingCycle",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = SubscriptionBaseMeta;

registerMeta(() => {});

export class SubscriptionBaseTracked implements SubscriptionBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  name__I?: string = undefined;
  nameIsSet: boolean = false;
  set name(v: undefined | string) {
    if (v !== undefined) {
      this.name__I = v;
      this.nameIsSet = true;
    } else {
      this.name__I = v || undefined;
      this.nameIsSet = true;
    }
    this.changeTracker = true;
  }
  get name() {
    return this.name__I;
  }
  billingCycle__I?: string = undefined;
  billingCycleIsSet: boolean = false;
  set billingCycle(v: undefined | string) {
    if (v !== undefined) {
      this.billingCycle__I = v;
      this.billingCycleIsSet = true;
    } else {
      this.billingCycle__I = v || undefined;
      this.billingCycleIsSet = true;
    }
    this.changeTracker = true;
  }
  get billingCycle() {
    return this.billingCycle__I;
  }
  constructor(config?: SubscriptionBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: SubscriptionBaseOptional,
    options?: AssignOptions,
  ): SubscriptionBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.name && this.nameApplyFilter(optionsRequired.filter)) {
      this.name = config.name;
      if (optionsRequired.unassign) this.nameIsSet = false;
      else this.nameIsSet = true;
    }
    if (
      config.billingCycle &&
      this.billingCycleApplyFilter(optionsRequired.filter)
    ) {
      this.billingCycle = config.billingCycle;
      if (optionsRequired.unassign) this.billingCycleIsSet = false;
      else this.billingCycleIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): SubscriptionBaseTrackedI {
    const cloned = {} as SubscriptionBaseTrackedI;
    if (
      this.nameIsSetDeep() &&
      this.nameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nameIsSet = true;
      cloned.name = this.name;
    } else {
      //cloned.nameIsSet = false
    }
    if (
      this.billingCycleIsSetDeep() &&
      this.billingCycleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.billingCycleIsSet = true;
      cloned.billingCycle = this.billingCycle;
    } else {
      //cloned.billingCycleIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): SubscriptionBaseTrackedI {
    if (!this.nameApplyFilter(filter)) this.nameIsSet = false;

    if (!this.billingCycleApplyFilter(filter)) this.billingCycleIsSet = false;

    return this;
  }
  nameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      SubscriptionBaseMeta.name,
      SubscriptionBaseMeta,
      this.name,
      this,
    );
  }
  nameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nameIsSet && this.nameApplyFilter(filter)) return true;

    return false;
  }
  billingCycleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      SubscriptionBaseMeta.billingCycle,
      SubscriptionBaseMeta,
      this.billingCycle,
      this,
    );
  }
  billingCycleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.billingCycleIsSet && this.billingCycleApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.nameIsSetDeep(filter)) return true;
    if (this.billingCycleIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
